import * as React from "react";
import { Alert, Modal, ProgressBar } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { EditWebinarPostModel, ErrorResultModel, IEditWebinarPostModel, SyncWebinarsRunningModel, SyncWebinarsStatus, WebinarResponseModel } from "../../swagger-clients/s365-admin-panel-clients.service";
import LoadingService from "../../components/loading-indicator/loading-indicator.service";
import { getWebinarsClient, getWebinarsSyncClient } from "../../services/api-clients.service";
import { stat } from "fs";

interface ISyncWebinarAttendanceProgressModalProps {
    show: boolean;
    onSuccess: () => void;
    onHide: () => void;
}


const SyncWebinarAttendanceProgressModal: React.FunctionComponent<ISyncWebinarAttendanceProgressModalProps> = (props) => {


    const intervalIdRef = React.useRef<NodeJS.Timeout>();
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const [status, setStatus] = React.useState<SyncWebinarsRunningModel>();
    const [isStatusLoaded, setIsStatusLoaded] = React.useState<boolean>(false);
    const [showProgressBar, setShowProgressBar] = React.useState<boolean>(true);
    const [processedCount, setProccessedCount] = React.useState<number>(0);
    const [totalCount, setTotalCount] = React.useState<number>(1);



    React.useEffect(() => {
        intervalIdRef.current = setInterval(() => {
            updateSyncStatus();
        }, 3000);

        return () => clearInterval(intervalIdRef.current);
    }, []);

    const stopStatusCheck = () => {
        if (intervalIdRef.current)
            clearInterval(intervalIdRef.current);
    }

    const onCloseClick = () => {
        setStatus(undefined);
        setShowProgressBar(false);
        setProccessedCount(0);
        setTotalCount(1);
        setErrorMessage(undefined);
        props.onHide();
    }

    const updateSyncStatus = async () => {

        try {

            setErrorMessage(undefined);
            const client = getWebinarsSyncClient();
            const status = await client.getSyncStatus();
            setIsStatusLoaded(true);
            setStatus(status);
            if (!!status) {
                setShowProgressBar(true);
                const finishedCount = (status.processed ?? 0) + (status.failed ?? 0);
                setProccessedCount(finishedCount);
                setTotalCount(status.total ?? 0);
                if (status.status !== SyncWebinarsStatus.Running) {
                    stopStatusCheck();
                }
                if (status.status == SyncWebinarsStatus.Failed) {
                    setErrorMessage("An error occurred while syncing webinars participants and registrants.");
                }



            }


        } catch (error) {
            stopStatusCheck();
            console.log("An error occurred while getting webinars resync status.", error);
            setErrorMessage("An error occurred while getting webinars resync status.");
        }
    }


    return <Modal
        show={props.show}
        onHide={onCloseClick}
        animation={false}
        centered
        backdrop="static"
    >
        <Modal.Header closeButton={true}>

            <Modal.Title>
                Sync webinars registrants and participants status
            </Modal.Title>
        </Modal.Header>

        <Modal.Body>
            {!!errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
            {!isStatusLoaded && !status && !errorMessage && <Alert variant="info">Loading status...</Alert>}
            {isStatusLoaded && !status && <Alert variant="danger">Sync status not found.</Alert>}
            {!errorMessage && isStatusLoaded && showProgressBar &&
                <ProgressBar
                    variant="success"
                    min={0}
                    max={totalCount}
                    now={processedCount}
                    animated
                    striped />}
            {!!status && status.status == SyncWebinarsStatus.Running && <Alert className="mt-2" variant="info">
                Synced {status.processed} of {status.total} webinars.
            </Alert>}
            {!!status && status.status == SyncWebinarsStatus.Finished && <Alert className="mt-2" variant="success">
                Synced {status.processed} of {status.total} webinars.
            </Alert>}
            {!!status && status.status == SyncWebinarsStatus.Finished && !!status.failed &&
                <Alert className="mt-2" variant="danger">Failed to sync {status.failed} webinars.</Alert>}

        </Modal.Body>



    </Modal>


}

export default SyncWebinarAttendanceProgressModal;